import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { EventApiModel } from './models/event.api.model';
import { EventQueryApiModel } from './models/event.query.api.model';

@Injectable()
export class EventsApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    // Admin only
    public searchAny(query: EventQueryApiModel): Observable<EventApiModel[]> {
        const slug: string = '/events/searchany';

        return this.neptuneApi.api<EventApiModel[]>(
            slug,
            query,
            HttpVerbsEnum.POST,
        );
    }

    public searchMine(query: EventQueryApiModel): Observable<EventApiModel[]> {
        const slug: string = '/events/searchmine';

        return this.neptuneApi.api<EventApiModel[]>(
            slug,
            query,
            HttpVerbsEnum.POST,
        );
    }
}
